import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

const CloseButton = ({ onClick }) => (
    <button className="close-button" onClick={onClick}>
        &times;
    </button>
);

CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/components/CloseButton/index.js